export const trunc = (text, length = 10, showDot = true) => {
  if (!text) return "";
  if (text?.length <= length) return text;
  return `${text?.substring(0, length)}${showDot ? "..." : ""}`;
};
